export const NOTIFICATION_MESSAGE = {
  LEAGUE_WINNER_1: 'Congrats on winning your league',
  LEAGUE_WINNER_2: 'Congrats on getting 2nd place in your league',
  WEEKLY_WINNER: 'Congrats on winning the weekly high score',
};
